// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"a8cea2ef","238":"6c915932","279":"b7d55ba6","396":"6c1996cc","676":"e006c1d6","717":"f7d22fe4","785":"95be6bef"}[chunkId] + ".chunk.js";
};